// extracted by mini-css-extract-plugin
export var body = "_k1-0";
export var sectionHeader = "_k1-4";
export var shortcutColumns = "_k1-2";
export var shortcutList = "_k1-1";
export var shortcutSection = "_k1-3";